<template>
  <div class="field">
    <label class="label">No-Go Companies</label>
    <div class="control">
      <textarea
        class="textarea has-text-right"
        dir="rtl"
        rows="2"
        placeholder="..."
        :value="value"
        @input="updateValue"
        @focusout="handleChange"
      ></textarea>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NoGoCompanies',
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    applicantId: {
      type: Number,
      required: true
    }
  },
  methods: {
    updateValue (event) {
      this.$emit('input', event.target.value)
    },
    async handleChange () {
      try {
        await this.$network_utils.updateApplicant({ applicant_id: this.applicantId, no_go_companies: this.value })
        this.$utils.emit('show_toast', { text: 'Success' })
      } catch (e) {
        this.$utils.emit('show_toast', { text: 'failed' })
      }
    }
  }
}
</script>
